<svg
  [attr.width]="size"
  [attr.height]="size"
  fill="none"
  viewBox="0 0 24 24"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M21 20C21.5523 20 22 20.4477 22 21C22 21.5523 21.5523 22 21 22H3C2.44772 22 2 21.5523 2 21C2 20.4477 2.44772 20 3 20H21ZM12 18L11.918 17.996L11.7993 17.9798L11.6879 17.9503L11.5768 17.9063L11.4793 17.854L11.4048 17.8037L11.2929 17.7071L7.29289 13.7071C6.90237 13.3166 6.90237 12.6834 7.29289 12.2929C7.65338 11.9324 8.22061 11.9047 8.6129 12.2097L8.70711 12.2929L11 14.585V3C11 2.44772 11.4477 2 12 2C12.5523 2 13 2.44772 13 3V14.585L15.2929 12.2929C15.6534 11.9324 16.2206 11.9047 16.6129 12.2097L16.7071 12.2929C17.0676 12.6534 17.0953 13.2206 16.7903 13.6129L16.7071 13.7071L12.7071 17.7071L12.6631 17.7485L12.5953 17.8037L12.4841 17.8753L12.4231 17.9063L12.3417 17.9401L12.266 17.9642L12.1175 17.9932L12 18Z"
    fill="currentColor"
  />
</svg>
